import Vue from 'vue'
import 'normalize.css/normalize.css'
import App from './App'
import router from './router'
import './permissions'
import store from '@/store'
import i18n from '@/i18n'
import Cookies from 'js-cookie'
import '@/utils/directives'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import '@/filters'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import Element from 'element-ui'
import '@/styles/element-ui/index.css'
import locale from 'element-ui/lib/locale/lang/vi'

import '@/styles/index.scss'
import './icons'

Vue.use(Viewer, {
  defaultOptions: {
    fullscreen: false
  }
})
Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale
})

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js